import axiosInstance from "../lib/axiosInstance";

const authModel = class {
    async login(data = []) {
        return await axiosInstance.post(process.env.REACT_APP_API_URL+"/adminapi/login/", data);
    }
}
export default new authModel();
